import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { RefreshCw, Calendar, ChevronRight } from "lucide-react";
import FindCaseStepper from "../../components/crm/FindCaseStepper";
import { renderTip } from "../../components/crm/formControls";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import SelectMenu from "../../components/crm/SelectMenu";
function ReraCaseSearch() {

const API_BASE = "https://jreraa.valscotech.com";
const HARYANA_API_BASE = "https://rera-haryana-596718606544.asia-south1.run.app";
// UP RERA (Regulatory Authority — up-rera.in). Distinct from the UP Appellate
// Tribunal above (state "UP"). This is state "UPRERA".
const UP_RERA_API_BASE = "https://up-rera-backend-596718606544.asia-south1.run.app";

// UP RERA search types that require a captcha (vs the cause-list types, which
// don't). Used to drive captcha loading + submit-button gating.
const UPRERA_CAPTCHA_TYPES = [
  "complaint-status",
  "conciliation-status",
  "complaint-aoa-status",
  "get-complaint-number",
];

const getApiUrl = (state, path) => {
  if (state.toUpperCase() === "HARYANA") {
    return `${HARYANA_API_BASE}/api/rera/hr${path}`;
  }
  return `${API_BASE}/api/rera/${state.toLowerCase()}${path}`;
};

const [advocateQuery, setAdvocateQuery] = useState("");
const [advocateSuggestions, setAdvocateSuggestions] = useState([]);
const [advocateLoading, setAdvocateLoading] = useState(false);
const [partyQuery, setPartyQuery] = useState("");


const toTitleCase = (str = "") =>
  str
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState('');
  const [captchaUrl, setCaptchaUrl] = useState('');
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
  const [debugInfo, setDebugInfo] = useState('');
  const [showDebug, setShowDebug] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
  // UI state selector: stateGroup picks the state; for Uttar Pradesh, upVariant
  // picks Appellate vs RERA. `state` (below) is the derived internal value all
  // the downstream logic keys on: "UP" | "UPRERA" | "DELHI" | "HARYANA".
  stateGroup: "DELHI",
  upVariant: "APPELLATE",
  state: "DELHI",
  search_by: "1",

  case_status: "PENDING",
  delhi_case_category: "",
  delhi_case_subcategory: "",

  // UP
  case_type: "",
  case_number: "",
  case_year: "",
  zonal_bench: "",
  party_name: "",
  party_type: "1",
  advocate_name: "",
  select_judge: "",
  from_date: "",
  to_date: "",
  answer: "",

  // HARYANA
  haryana_authority: "",
  haryana_case_no: "",
  haryana_case_year: "",
  haryana_captcha: "",

  // UP RERA (up-rera.in / Regulatory Authority)
  uprera_search_type: "complaint-status",
  uprera_complaint_number: "",
  uprera_conciliation_no: "",
  uprera_gcn_search_type: "transaction", // transaction | email
  uprera_transaction_id: "",
  uprera_email: "",
  uprera_mobile: "",
  uprera_officer_id: "",
  uprera_forum_code: "",
  uprera_hearing_date: "",
  uprera_captcha: "",
  uprera_captcha2: ""
});

// UP RERA captcha session — carries viewState + cookie jar from the /captcha
// response back into /search (the up-rera.in ASP.NET session that issued the
// captcha image). Kept separate from the sessionId-based UP/HARYANA flow.
const [upReraCaptcha1, setUpReraCaptcha1] = useState("");
const [upReraCaptcha2, setUpReraCaptcha2] = useState("");
const [upReraViewState, setUpReraViewState] = useState(null);
const [upReraJar, setUpReraJar] = useState(null);

// Captcha load state — shown inside the captcha box (spinner / error) instead
// of the top status banner.
const [captchaLoading, setCaptchaLoading] = useState(false);
const [captchaError, setCaptchaError] = useState("");



useEffect(() => {
  setFormData(prev => ({
    ...prev,
    case_type: "",
    case_number: "",
    case_year: "",
    party_name: "",
    party_type: "1",
    advocate_name: "",
    select_judge: "",
    from_date: "",
    to_date: ""
  }));
}, [formData.search_by]);





useEffect(() => {
  setSessionId('');
  setCaptchaUrl('');

  if (formData.state === "UP" || formData.state === "HARYANA") {
    loadCaptcha();
  }
}, [formData.state]);


// UP RERA: (re)load the captcha whenever the state or the chosen search type
// changes; clear it entirely when leaving UP RERA.
useEffect(() => {
  if (formData.state === "UPRERA") {
    loadUpReraCaptcha();
  } else {
    setUpReraCaptcha1("");
    setUpReraCaptcha2("");
    setUpReraViewState(null);
    setUpReraJar(null);
  }
}, [formData.state, formData.uprera_search_type]);



  // Clear localStorage when component mounts (fresh search)
  useEffect(() => {
    localStorage.removeItem('rera_search_payload');
    localStorage.removeItem('rera_case_details_payload');
  }, []);

  const showStatus = (message, type = 'info') => {
    setStatusMessage({ text: message, type });
    setTimeout(() => setStatusMessage({ text: '', type: '' }), 5000);
  };

  const loadCaptcha = async () => {
    if (formData.state === "UP" || formData.state === "HARYANA") {

    try {
      setCaptchaLoading(true);
      setCaptchaError("");
      setCaptchaUrl("");
      const res = await fetch(
  getApiUrl(formData.state, "/generateCaptcha")
);


      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }

      const data = await res.json();

      if (data.error) {
        throw new Error(data.error);
      }

      setSessionId(data.sessionId);
      setCaptchaUrl(data.captcha);
      setFormData(prev => ({ ...prev, answer: '', haryana_captcha: '' }));

      console.log('✅ Captcha loaded successfully');
      console.log('Session ID:', data.sessionId);

    } catch (e) {
      console.error('❌ Failed to load captcha:', e);
      setCaptchaError("Failed to load captcha. Tap refresh to retry.");
    } finally {
      setCaptchaLoading(false);
    }
  };}

// Load a captcha for the currently-selected UP RERA search type. Cause-list
// types need none, so we just clear the captcha session for those.
const loadUpReraCaptcha = async () => {
  const type = formData.uprera_search_type;

  if (!UPRERA_CAPTCHA_TYPES.includes(type)) {
    setUpReraCaptcha1("");
    setUpReraCaptcha2("");
    setUpReraViewState(null);
    setUpReraJar(null);
    setCaptchaError("");
    return;
  }

  try {
    setCaptchaLoading(true);
    setCaptchaError("");
    setUpReraCaptcha1("");
    setUpReraCaptcha2("");
    const res = await fetch(`${UP_RERA_API_BASE}/${type}/captcha`);
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

    const data = await res.json();
    if (data.error) throw new Error(data.error);

    // get-complaint-number returns captchaImage1/2; the rest return captchaImage
    setUpReraCaptcha1(data.captchaImage1 || data.captchaImage || "");
    setUpReraCaptcha2(data.captchaImage2 || "");
    setUpReraViewState(data.viewState || null);
    setUpReraJar(data.jar || null);
    setFormData(prev => ({ ...prev, uprera_captcha: "", uprera_captcha2: "" }));
  } catch (e) {
    console.error("❌ Failed to load UP RERA captcha:", e);
    setCaptchaError("Failed to load captcha. Tap refresh to retry.");
  } finally {
    setCaptchaLoading(false);
  }
};

// Convert a native <input type="date"> value (yyyy-mm-dd) into the format the
// UP RERA cause-list endpoints expect.
const formatUpReraDate = (iso, sep) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return [d, m, y].join(sep);
};

const fetchAdvocateSuggestions = async (term) => {
  if (!term || term.length < 1) {
    setAdvocateSuggestions([]);
    return;
  }

  if (!sessionId) {
    console.warn("No sessionId for advocate autocomplete");
    return;
  }

  try {
    setAdvocateLoading(true);

    const res = await fetch(
      getApiUrl("UP", "/advocateAutocomplete"),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          term,
          sessionId   // 🔥 REQUIRED
        })
      }
    );

    const data = await res.json();

    // Backend usually returns { names: [] }
    const names = Array.isArray(data)
      ? data
      : Array.isArray(data.names)
      ? data.names
      : [];

    setAdvocateSuggestions(names);
  } catch (e) {
    console.error("Advocate autocomplete failed", e);
    setAdvocateSuggestions([]);
  } finally {
    setAdvocateLoading(false);
  }
};


  const DELHI_SUBCATEGORY_MAP = {
  PENDING: {
    complaint: [
      { value: "complaint", label: "Complaint Cases" }
    ],
    execution: [
      { value: "execution", label: "Execution Cases" }
    ],
    "suo-moto": [
      { value: "agent", label: "Suo-Moto (Agent)" },
      { value: "project", label: "Suo-Moto (Project)" },
      { value: "general", label: "Suo-Moto (General)" },
      { value: "ao-project", label: "AO Suo-Moto (Project)" }
    ],
    general: [
      { value: "agent", label: "General (Agent)" },
      { value: "project", label: "General (Project)" }
    ],
    registration: [
      { value: "agent", label: "Registration (Agent)" },
      { value: "project", label: "Registration (Project)" }
    ]
  },

  DISPOSED: {
    complaint: [
      { value: "complaint", label: "Disposed Complaints" }
    ],
    execution: [
      { value: "execution", label: "Disposed Execution Cases" }
    ],
    "suo-moto": [
      { value: "agent", label: "Disposed Suo-Moto (Agent)" },
      { value: "project", label: "Disposed Suo-Moto (Project)" }
    ],
    general: [
      { value: "agent", label: "Disposed General (Agent)" }
    ],
    registration: [
      { value: "agent", label: "Disposed Registration (Agent)" }
    ]
  }
};



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Map the UI selectors (stateGroup + upVariant) to the internal `state` value
  // the rest of the form keys on.
  const deriveState = (group, variant) => {
    if (group === "DELHI") return "DELHI";
    if (group === "HARYANA") return "HARYANA";
    if (group === "UTTAR_PRADESH") return variant === "RERA" ? "UPRERA" : "UP";
    return "";
  };

  const handleStateGroupChange = (e) => {
    const group = e.target.value;
    setFormData(prev => ({
      ...prev,
      stateGroup: group,
      state: deriveState(group, prev.upVariant),
    }));
  };

  const handleUpVariantChange = (e) => {
    const variant = e.target.value;
    setFormData(prev => ({
      ...prev,
      upVariant: variant,
      state: deriveState("UTTAR_PRADESH", variant),
    }));
  };

  const handleDebug = async () => {
    if (!sessionId) {
      alert('⚠️ Load captcha first to create a session!');
      return;
    }
    
    try {
      showStatus('Fetching session debug info...', 'info');
      const res = await fetch(getApiUrl(formData.state, `/debugSession/${sessionId}`));
      const data = await res.json();
      
      console.log('=== 🔍 SESSION DEBUG ===');
      console.log('Session ID:', sessionId);
      console.log('Cookie:', data.cookie);
      console.log('Hidden Fields:', data.tokenFields);
      
      setDebugInfo(JSON.stringify(data, null, 2));
      setShowDebug(true);
      showStatus('✅ Debug info logged to console!', 'success');
      
    } catch (e) {
      console.error('❌ Debug failed:', e);
      showStatus('❌ Debug failed: ' + e.message, 'error');
    }
  };


// const transformDelhiCases = (rows) => ({
//   sessionID: "rera_delhi_" + Date.now(),
//   data: {
//     con: rows.map((row, index) => ({
//       sno: index + 1,

//       filing_no: row.caseNo || `DELHI-${index + 1}`,

//       case_type_no: "RERA Case",

//       case_title:
//         row.complainant || row.respondent
//           ? `${row.complainant || ""} VS ${row.respondent || ""}`
//           : "—",

//       bench_location: "DELHIREAT-Shivaji Stadium Annexe Building",

//       registration_date: row.filedOn || "N/A",

//       main_case_filing_no: "N/A",

//       next_listing: row.nextHearing || "N/A",

//       case_status: "Pending",

//       pet_name: row.complainant || "",
//       res_name: row.respondent || "",

//       orderurlpath: row.orderLink || "",
//       noticeurlpath: row.noticeLink || ""
//     }))
//   }
// });

const DELHI_DISPOSED_ENDPOINTS = {
  complaint: "/disposed/complaints",

  execution: "/disposed/execution",

  registration: {
    agent: "/disposed/registration-agents",
    project: "/disposed/registration/projects",
  },

  general: {
    agent: "/disposed/general-agents",
    project: "/disposed/general-projects",
  },

  "suo-moto": {
    agent: "/disposed/suo-moto-agent",
    project: "/disposed/suo-moto-project",
  },
};

const getDelhiEndpoint = (formData) => {
  const { case_status, delhi_case_category, delhi_case_subcategory } = formData;

  if (case_status === "PENDING") {
    switch (delhi_case_category) {
      case "complaint":
        return "/ongoingComplaints";

      case "execution":
        return "/executionCases";

      case "registration":
        return delhi_case_subcategory === "agent"
          ? "/registration/agents"
          : "/registration/projects";

      case "general":
        return delhi_case_subcategory === "agent"
          ? "/general/agents"
          : "/general/projects";

      case "suo-moto":
        if (delhi_case_subcategory === "ao-project") {
    return "/ao/suo-moto/project";
  }
  return `/suo-moto/${delhi_case_subcategory}`;

      default:
        return null;
    }
  }

  // ✅ DISPOSED (CORRECT + SAFE)
  const disposed = DELHI_DISPOSED_ENDPOINTS[delhi_case_category];

  if (!disposed) return null;

  if (typeof disposed === "string") {
    return disposed;
  }

  return disposed[delhi_case_subcategory] || null;
};



  const handleSubmit = async (e) => {
    console.log("HANDLE SUBMIT FIRED");

  e.preventDefault();
  const searchBy = String(formData.search_by);


  if (formData.state === "UP") {
    const requiredMap = {
  "1": ["case_number", "case_year"],   
  "2": ["case_type", "case_year"],     
  "3": ["case_type", "case_number", "case_year"],
  "4": ["party_name", "case_year"],
  "5": ["advocate_name", "case_year"],
  "6": ["select_judge"],               
};




    for (const field of requiredMap[formData.search_by] || []) {
      if (!formData[field]) {
        alert(`Please fill ${field.replace("_", " ")}`);
        return;
      }
    }
  }

    
    const { search_by, case_type, case_number, case_year, answer } = formData;

    


if (formData.state === "DELHI") {
  if (!formData.case_status || !formData.delhi_case_category || !formData.delhi_case_subcategory) {
    alert("Please complete Delhi case selection");
    return;
  }
}

if (formData.state === "HARYANA") {
  if (!formData.haryana_authority || !formData.haryana_case_no || !formData.haryana_case_year) {
    alert("Please fill all Haryana fields");
    return;
  }

  if (!sessionId) {
    alert("Session expired. Reloading captcha...");
    await loadCaptcha();
    return;
  }

  if (!formData.haryana_captcha.trim()) {
    alert("Please type the captcha");
    return;
  }

  try {
    setLoading(true);
    showStatus("Searching Haryana RERA cases...", "info");

    const hRes = await fetch(getApiUrl("HARYANA", "/submitSearch"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        captchaText: formData.haryana_captcha,
        complaintNo: formData.haryana_case_no,
        complaintYear: formData.haryana_case_year,
        authority: formData.haryana_authority,
      }),
    });

    if (!hRes.ok) throw new Error(`HTTP ${hRes.status}`);

    const hJson = await hRes.json();

    if (!hJson.success || !Array.isArray(hJson.data) || !hJson.data.length) {
      showStatus("⚠️ No cases found", "error");
      setTimeout(() => loadCaptcha(), 1000);
      setLoading(false);
      return;
    }

    showStatus(`✅ Found ${hJson.data.length} case(s)`, "success");

    sessionStorage.setItem("haryanaReraSessionId", sessionId);
    localStorage.setItem("haryanaReraSessionId", sessionId);

    const hHeaders = [
      "Complaint ID",
      "Complainant",
      "Respondent",
      "Representative",
      "Status",
      "Next Date",
      "Action",
    ];

    const hRows = hJson.data.map((c) => ({
      "Complaint ID": c.complaintId || "—",
      "Complainant": c.complainantName || "—",
      "Respondent": c.respondentName || "—",
      "Representative": c.representative || "—",
      "Status": c.status || "—",
      "Next Date": c.nextDate || "—",
      "Action": {
        text: "View Details",
        internalId: c.action?.internalId || "",
        filingNo: c.complaintId || "",
      },
    }));

    navigate("/portal/rera/caseList", {
      state: {
        data: { headers: hHeaders, rows: hRows },
        searchParams: {
          state_code: "HARYANA",
          courtType: "RERA",
          sessionId,
        },
      },
    });

    setLoading(false);
    return;
  } catch (e) {
    console.error("Haryana search error:", e);
    showStatus("❌ Error: " + e.message, "error");
    setTimeout(() => loadCaptcha(), 1000);
    setLoading(false);
    return;
  }
}


    if (formData.state === "UPRERA") {
  const type = formData.uprera_search_type;
  const needsCaptcha = UPRERA_CAPTCHA_TYPES.includes(type);

  // Captcha-session guard (the four captcha-based types)
  if (needsCaptcha && (!upReraViewState || !upReraJar)) {
    alert("Session expired. Reloading captcha...");
    await loadUpReraCaptcha();
    return;
  }

  let endpoint = "";
  let payload = {};

  if (type === "complaint-status" || type === "complaint-aoa-status") {
    if (!formData.uprera_complaint_number.trim()) {
      alert("Please enter the complaint number");
      return;
    }
    if (!formData.uprera_captcha.trim()) {
      alert("Please type the captcha");
      return;
    }
    endpoint = `/${type}/search`;
    payload = {
      complaint_number: formData.uprera_complaint_number.trim(),
      captcha_input: formData.uprera_captcha.trim(),
      viewState: upReraViewState,
      jar: upReraJar,
    };
  } else if (type === "conciliation-status") {
    if (!formData.uprera_conciliation_no.trim()) {
      alert("Please enter the conciliation number");
      return;
    }
    if (!formData.uprera_captcha.trim()) {
      alert("Please type the captcha");
      return;
    }
    endpoint = "/conciliation-status/search";
    payload = {
      conciliation_no: formData.uprera_conciliation_no.trim(),
      captcha_input: formData.uprera_captcha.trim(),
      viewState: upReraViewState,
      jar: upReraJar,
    };
  } else if (type === "get-complaint-number") {
    const byEmail = formData.uprera_gcn_search_type === "email";
    if (byEmail && !formData.uprera_email.trim()) {
      alert("Please enter the email");
      return;
    }
    if (!byEmail && !formData.uprera_transaction_id.trim()) {
      alert("Please enter the transaction ID");
      return;
    }
    if (!formData.uprera_captcha.trim()) {
      alert("Please type the captcha");
      return;
    }
    if (upReraCaptcha2 && !formData.uprera_captcha2.trim()) {
      alert("Please type the second captcha");
      return;
    }
    endpoint = "/get-complaint-number/search";
    payload = {
      search_type: byEmail ? "email" : "transaction",
      transaction_id: formData.uprera_transaction_id.trim(),
      email: formData.uprera_email.trim(),
      mobile: formData.uprera_mobile.trim(),
      captcha_input: formData.uprera_captcha.trim(),
      captcha_input2: formData.uprera_captcha2.trim(),
      viewState: upReraViewState,
      jar: upReraJar,
    };
  } else if (type === "complaint-cause-list") {
    if (!formData.uprera_officer_id) {
      alert("Please select a hearing officer");
      return;
    }
    if (!formData.uprera_hearing_date) {
      alert("Please select a hearing date");
      return;
    }
    endpoint = "/complaint-cause-list";
    payload = {
      officer_id: formData.uprera_officer_id,
      hearing_date: formatUpReraDate(formData.uprera_hearing_date, "-"), // DD-MM-YYYY
    };
  } else if (type === "conciliation-cause-list") {
    if (!formData.uprera_forum_code) {
      alert("Please select a forum");
      return;
    }
    if (!formData.uprera_hearing_date) {
      alert("Please select a hearing date");
      return;
    }
    endpoint = "/conciliation-cause-list";
    payload = {
      forum_code: formData.uprera_forum_code,
      hearing_date: formatUpReraDate(formData.uprera_hearing_date, "/"), // DD/MM/YYYY
    };
  }

  try {
    setLoading(true);

    const r = await fetch(`${UP_RERA_API_BASE}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!r.ok) {
      const errJson = await r.json().catch(() => ({}));
      throw new Error(errJson.error || errJson.message || `HTTP ${r.status}`);
    }

    const j = await r.json();

    setLoading(false);

    // Complaint Status is a single rich record → dedicated detail page (the
    // original site shows it as a sectioned detail view, not a list).
    if (type === "complaint-status") {
      navigate("/portal/rera/upComplaintDetail", {
        state: { detail: j.detail },
      });
      return;
    }

    // Everything else is a list/grid → shared caseList (which shows a clean
    // empty state when there are no records).
    const results = Array.isArray(j.results) ? j.results : [];
    const headers = results.length ? Object.keys(results[0]) : [];

    navigate("/portal/rera/caseList", {
      state: {
        data: { headers, rows: results },
        searchParams: {
          courtType: "RERA",
          state_code: "UPRERA",
        },
      },
    });
    return;
  } catch (e) {
    console.error("UP RERA search error:", e);
    showStatus("❌ Error: " + e.message, "error");
    if (needsCaptcha) setTimeout(() => loadUpReraCaptcha(), 1000);
    setLoading(false);
    return;
  }
}


    if (formData.state === "UP" && !sessionId) {
  alert("Session expired. Reloading captcha...");
  await loadCaptcha();
  return;
}

if (formData.state === "UP" && !formData.answer.trim()) {
  alert("Please type the captcha");
  return;
}


    try {
      setLoading(true);
      showStatus('Submitting form...', 'info');
      
      let payload;

if (formData.state === "UP") {
  payload = {
  sessionId,
  captchaText: formData.answer,
  formFields: {
    search_by: searchBy,

...(searchBy === "1" && {
  diary_no: formData.case_number,
  case_year: formData.case_year,
}),



    ...(searchBy === "2" && {
      case_type: formData.case_type,
      case_year: formData.case_year,
    }),

    ...(searchBy === "3" && {
      case_type: formData.case_type,
      case_number: formData.case_number,
      case_year: formData.case_year,
    }),

    ...(searchBy === "4" && {
      party_name: formData.party_name,
      party_type: formData.party_type,
      case_year: formData.case_year,
    }),

    ...(searchBy === "5" && {
      advocate_name: formData.advocate_name,
      case_year: formData.case_year,
    }),

    ...(searchBy === "6" && {
  select_judge: formData.select_judge,
  ...(formData.from_date && { from_date: formData.from_date }),
  ...(formData.to_date && { to_date: formData.to_date }),
}),

  },
};

}


if (formData.state === "DELHI") {
  



  const endpoint = getDelhiEndpoint(formData);

  if (!endpoint) {
    showStatus("❌ Invalid Delhi selection", "error");
    setLoading(false);
    return;
  }


  showStatus("Fetching Delhi cases...", "info");

  const r = await fetch(getApiUrl(formData.state, endpoint));


  if (!r.ok) {
    throw new Error(`HTTP ${r.status}`);
  }

  const j = await r.json();
  console.log("🧪 RAW BACKEND RESPONSE:", j);
  console.log("🧪 NORMALIZED PAYLOAD:", j.data || j);


   // ✅ Delhi always returns rows inside `rows`
const rows = Array.isArray(j.rows)
  ? j.rows
  : Array.isArray(j.data?.rows)
  ? j.data.rows
  : [];
  


  
// 🔍 Debug once
console.log("DELHI rows count:", rows.length);

if (!rows.length) {
  showStatus("⚠️ No records found", "error");
  setLoading(false);
  return;
}


  showStatus(`✅ Found ${rows.length} case(s)`, "success");



  let headers =
  Array.isArray(j.headers) && j.headers.length
    ? j.headers
    : Array.isArray(j.data?.headers) && j.data.headers.length
    ? j.data.headers
    : [];

// ✅ FIX ONLY FOR ONGOING COMPLAINTS
if (
  endpoint === "/ongoingComplaints" &&
  rows.length &&
  headers.length === 0
) {
  headers = [
    "Case No",
    "Filed On",
    "Complainant",
    "Respondent",
    "Last Hearing",
    "Next Hearing",
    "Notice",
    "Order"
  ];
}


  

// const alignedRows = mapHeadersToRow(headers, rows);
const mapDelhiRowsToTable = (rows) => {
  return rows.map(r => ({
    col1: r.caseNo || "—",
    col2: r.filedOn || "—",
    col3: `${r.complainant || "—"} VS ${r.respondent || "—"}`,
    col4: r.lastHearing || "—",
    col5: r.nextHearing || "—",
    col6: r.noticeLink
      ? { text: "Notice", link: r.noticeLink }
      : "—",
    col7: r.orderLink
      ? { text: "Order", link: r.orderLink }
      : "—",
    col8: "Pending"
  }));
};
const normalizeValue = (row, header) => {
  const key = header.replace(/\s+/g, "").toLowerCase();

  // Common auto matches
  return (
    row[header] ??
    row[key] ??
    row[key.replace("no", "No")] ??
    row[key.replace("on", "On")] ??
    row[key.replace("date", "Date")] ??
    "—"
  );
};

const resolveValue = (row, header) => {
  const key = header.replace(/\s+/g, "");

  return (
    row[header] ??
    row[key] ??
    row[key.charAt(0).toLowerCase() + key.slice(1)] ?? // ✅ lastHearing / nextHearing
    row[key.toLowerCase()] ??
    "—"
  );
};


const mapRowsByHeaders = (headers, rows, endpoint) => {
  return rows.map(row => {
    // Preserve raw fields (caseNo, filedOn, complainant, Notice array, etc.)
    // so the export step can read them without depending on header-style keys.
    const mapped = { ...row };

    headers.forEach(h => {
      // 🔹 ONGOING COMPLAINTS: Notice / Order arrive as arrays of {text, link}
      if (endpoint === "/ongoingComplaints") {
        if (h === "Notice") {
          mapped[h] = Array.isArray(row.Notice)
            ? row.Notice
            : row.noticeLink
            ? [{ text: "Notice", link: row.noticeLink }]
            : "—";
          return;
        }

        if (h === "Order") {
          mapped[h] = Array.isArray(row.Order)
            ? row.Order
            : row.orderLink
            ? [{ text: "Order", link: row.orderLink }]
            : "—";
          return;
        }
      }

      const value = resolveValue(row, h);

      mapped[h] =
        typeof value === "string" && value.startsWith("http")
          ? { text: "View", link: value }
          : value;
    });

    return mapped;
  });
};


const mappedRows = mapRowsByHeaders(headers, rows, endpoint);


navigate("/portal/rera/caseList", {
  state: {
    data: {
      headers,
      rows: mappedRows
    },
    searchParams: {
      state_code: "DELHI",
      courtType: "RERA"
    }
  }
});




  setLoading(false);
  return;
}


      console.log('📤 Submitting:', payload);

      const r = await fetch(
  getApiUrl(formData.state, "/submitSearch"),
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }
);


      if (!r.ok) {
        throw new Error(`HTTP ${r.status}: ${r.statusText}`);
      }

      const j = await r.json();
      // 🔥 NORMALIZE BACKEND RESPONSE
if (formData.state === "UP") {
  if (!j.data || !j.data.rows || !j.data.rows.length) {
  showStatus("⚠️ No cases found", "error");
  return;
}


  const upPayload = j.data;
  const rows = upPayload.rows || [];

  if (!rows.length) {
    showStatus("⚠️ No cases found", "error");
    return;
  }

  const headers = upPayload.headers || Object.keys(rows[0] || {});
  sessionStorage.setItem("upReraSessionId", sessionId);
localStorage.setItem("upReraSessionId", sessionId);


  navigate("/portal/rera/caseList", {
    state: {
      data: {
        headers,
        rows
      },
      searchParams: {
        courtType: "RERA",
        state_code: "UP",
        sessionId
      }
    }
  });

  return;
}



  // const rows = summary.map(row => ({
  //   ...row,
  //   Action: {
  //     text: "View",
  //     filingNo:
  //       row["Filing No"] ||
  //       row["Filing Number"] ||
  //       row["Diary No"] ||
  //       row["Diary Number"]
  //   }
  // }));

      
      console.log('📥 Response:', j);
      
      if (j.success && formData.state !== "UP") {
        if (payload.type === 'table' && payload.rows) {
          const validRows = payload.rows.filter(row => {
            const values = Object.values(row);
            return values.some(v => v && v.trim() !== '');
          });
          
          if (validRows.length > 0) {
            // Transform RERA response to match High Court format
          
            
            showStatus(`✅ Success! Found ${validRows.length} result(s)`, 'success');
            
            console.log('📊 Case Details:');
            validRows.forEach((row, idx) => {
              console.log(`\nResult ${idx + 1}:`);
              console.log('  Filing No:', row.col1 || 'N/A');
              console.log('  Case:', row.col2 || 'N/A');
              console.log('  Parties:', row.col3 || 'N/A');
              console.log('  Filing Date:', row.col4 || 'N/A');
              console.log('  Status:', row.col5 || 'N/A');
            });

            // Store initial search payload in localStorage
            localStorage.setItem('rera_search_payload', JSON.stringify(payload));

            const headers = [
  "Sr. No.",
  "Filing No.",
  "Case No.",
  "Case Title",
  "Registration Date",
  "Status",
  "Action",
];

const rows = validRows.map((r, index) => ({
  "Sr. No.": index + 1,
  "Filing No.": r.col2 || "—",
  "Case No.": r.col3 || "—",     // contains multiline Appeal + IA
  "Case Title": r.col4 || "—",
  "Registration Date": r.col5 || "—",
  "Status": r.col6 || "—",
  "Action": r.col7
    ? { text: "View", link: r.col6 }
    : "—",
}));

navigate("/portal/rera/caseList", {
  state: {
    data: { headers, rows },
    searchParams: {
      courtType: "RERA",
      state_code: "UP",
    },
  },
});


          } else {
            showStatus('⚠️ No valid results found', 'error');
          }
        } else if (payload.type === 'html') {
  console.log(payload.html);
}

      } else {
        showStatus('❌ Submission failed. Check console.', 'error');
      }
      
      // 🔁 Reload captcha ONLY on failure
if (
  formData.state === "UP" &&
  (!j.success || j.code === "RELOAD_CAPTCHA")
) {
  setTimeout(() => loadCaptcha(), 1000);
}


      
    } catch (e) {
      console.error('❌ Submission error:', e);
      showStatus('❌ Error: ' + e.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const [lightMode, setLightMode] = useState(() => {
          const storedLightMode = localStorage.getItem('lightMode');
          const storedTheme = localStorage.getItem('theme');
          if (storedLightMode !== null) {
            return storedLightMode === 'true';
          }
          if (storedTheme) {
            return storedTheme === 'light';
          }
          return false;
        });
    
        useEffect(() => {
      const handler = () => {
        setLightMode(localStorage.getItem("theme") === "light");
      };
      window.addEventListener("storage", handler);
      return () => window.removeEventListener("storage", handler);
    }, []);
    


    

  // Field styling matching the shared court-search look (native select arrow kept).
  const inputStyles = "h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 placeholder-slate-400 outline-none transition-colors focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/30";
  const selectStyles = "h-10 w-full cursor-pointer rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition-colors focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/30";
  return (
    <div className="min-h-screen bg-[#F8FAFC]">

      {/* Loading modal — shown while a search is in flight */}
      {loading && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="flex flex-col items-center gap-4 rounded-2xl border border-slate-200 bg-white px-10 py-8 shadow-2xl">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-yellow-500/30 border-t-yellow-500"></div>
            <p className="text-slate-800 text-base font-semibold">Searching cases…</p>
            <p className="text-slate-500 text-sm">This may take a few moments. Please wait.</p>
          </div>
        </div>
      )}

        <main className="px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-1.5 text-sm">
            <Link to="/portal/findCasesOptions" className="text-slate-500 hover:text-slate-800">Find Cases</Link>
            <ChevronRight className="h-4 w-4 text-slate-400" />
            <span className="font-medium text-slate-800">RERA</span>
          </div>
          <div className="mt-4"><FindCaseStepper current={2} /></div>

          {statusMessage.text && (
            <div className="mt-4 mb-2">
              <div className={`rounded-lg px-3 py-2 text-sm ring-1 ${
                statusMessage.type === 'success' ? 'bg-green-50 text-green-700 ring-green-100' :
                statusMessage.type === 'error' ? 'bg-red-50 text-red-600 ring-red-100' :
                'bg-blue-50 text-blue-700 ring-blue-100'
              }`}>
                {statusMessage.text}
              </div>
            </div>
          )}

          <div className="mt-4">
  <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white text-slate-800 shadow-sm">
              <form onSubmit={handleSubmit}>
  <div className="p-5 sm:p-6">
    <h2 className="mb-5 text-sm font-semibold text-slate-800">RERA : Search Cases</h2>
  <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-x-6 gap-y-4">
    {/* LEFT COLUMN - 4 fields */}
      <div className="space-y-4">

      {/* State */}
      <div>
        <label className="block mb-1.5 text-slate-600 text-sm font-medium">
          State <span className="text-red-500">*</span>
        </label>
        <SelectMenu
          name="stateGroup"
          value={formData.stateGroup}
          onChange={handleStateGroupChange}
          className={selectStyles}
        >
          <option value="">-- Select State --</option>
          <option value="UTTAR_PRADESH">UTTAR PRADESH</option>
          <option value="DELHI">DELHI</option>
          <option value="HARYANA">HARYANA</option>
        </SelectMenu>
      </div>

      {/* UP authority — only when Uttar Pradesh is selected */}
      {formData.stateGroup === "UTTAR_PRADESH" && (
        <div>
          <label className="block mb-1.5 text-slate-600 text-sm font-medium">
            Authority <span className="text-red-500">*</span>
          </label>
          <SelectMenu
            name="upVariant"
            value={formData.upVariant}
            onChange={handleUpVariantChange}
            className={selectStyles}
          >
            <option value="APPELLATE">UP RERA Appellate</option>
            <option value="RERA">UP RERA</option>
          </SelectMenu>
        </div>
      )}
      {formData.state === "DELHI" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case Status <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="case_status"
      value={formData.case_status}
      onChange={handleInputChange}
      className={selectStyles}
    >
      <option value="PENDING">Pending</option>
      <option value="DISPOSED">Disposed</option>
    </SelectMenu>
  </div>
)}

{formData.state === "UP" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Choose Type <span className="text-red-500">*</span>
    </label>
    <SelectMenu
  name="search_by"
  value={formData.search_by}
  onChange={handleInputChange}
  className={selectStyles}
>
  <option value="1">Filing Number</option>
<option value="2">Case Type</option>
<option value="3">Case Number</option>
<option value="4">Party Name</option>
<option value="5">Advocate Name</option>
{/* <option value="6">Judge Name</option> */}

</SelectMenu>

  </div>
)}

{/* ===================== UP RERA (up-rera.in) ===================== */}
{formData.state === "UPRERA" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Choose Type <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="uprera_search_type"
      value={formData.uprera_search_type}
      onChange={handleInputChange}
      className={selectStyles}
    >
      <option value="complaint-status">Complaint Status</option>
      <option value="conciliation-status">Conciliation Status</option>
      <option value="complaint-aoa-status">Complaint AOA Status</option>
      <option value="get-complaint-number">Get Complaint Number</option>
      <option value="complaint-cause-list">Complaint Cause List</option>
      <option value="conciliation-cause-list">Conciliation Cause List</option>
    </SelectMenu>
  </div>
)}

{/* Complaint number (complaint status / AOA status) */}
{formData.state === "UPRERA" &&
  ["complaint-status", "complaint-aoa-status"].includes(formData.uprera_search_type) && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Complaint Number <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="uprera_complaint_number"
      value={formData.uprera_complaint_number}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="e.g. LKO162/09/132943/2025"
    />
  </div>
)}

{/* Conciliation number */}
{formData.state === "UPRERA" && formData.uprera_search_type === "conciliation-status" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Conciliation Number <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="uprera_conciliation_no"
      value={formData.uprera_conciliation_no}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter conciliation number"
    />
  </div>
)}

{/* Get complaint number */}
{formData.state === "UPRERA" && formData.uprera_search_type === "get-complaint-number" && (
  <>
    <div>
      <label className="block mb-1.5 text-slate-600 text-sm font-medium">
        Search By <span className="text-red-500">*</span>
      </label>
      <SelectMenu
        name="uprera_gcn_search_type"
        value={formData.uprera_gcn_search_type}
        onChange={handleInputChange}
        className={selectStyles}
      >
        <option value="transaction">Transaction ID</option>
        <option value="email">Email + Mobile</option>
      </SelectMenu>
    </div>

    {formData.uprera_gcn_search_type === "transaction" ? (
      <div>
        <label className="block mb-1.5 text-slate-600 text-sm font-medium">
          Transaction ID <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="uprera_transaction_id"
          value={formData.uprera_transaction_id}
          onChange={handleInputChange}
          className={inputStyles}
          placeholder="Enter transaction ID"
        />
      </div>
    ) : (
      <>
        <div>
          <label className="block mb-1.5 text-slate-600 text-sm font-medium">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="uprera_email"
            value={formData.uprera_email}
            onChange={handleInputChange}
            className={inputStyles}
            placeholder="Enter email"
          />
        </div>
        <div>
          <label className="block mb-1.5 text-slate-600 text-sm font-medium">Mobile</label>
          <input
            type="text"
            name="uprera_mobile"
            value={formData.uprera_mobile}
            onChange={handleInputChange}
            className={inputStyles}
            placeholder="Enter mobile (optional)"
          />
        </div>
      </>
    )}
  </>
)}

{/* Complaint cause list: hearing officer */}
{formData.state === "UPRERA" && formData.uprera_search_type === "complaint-cause-list" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Hearing Officer <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="uprera_officer_id"
      value={formData.uprera_officer_id}
      onChange={handleInputChange}
      className={selectStyles}
    >
      <option value="">-- Select Officer --</option>
      <option value="79">Bench 1 Lucknow</option>
      <option value="70">Bench 2 Lucknow</option>
      <option value="71">Bench 3 Lucknow</option>
      <option value="78">Bench 1 GBN</option>
      <option value="72">Bench 2 GBN</option>
      <option value="73">Bench 3 GBN</option>
      <option value="76">Bench 4 GBN</option>
      <option value="77">Adjudicating Officer Lucknow</option>
      <option value="89">Adjudicating Officer GBN</option>
      <option value="74">Secretary LKO</option>
      <option value="75">Secretary GBN</option>
      <option value="93">Authority At LKO</option>
      <option value="90">Authority At NCR</option>
      <option value="95">Divisional Lucknow</option>
      <option value="97">Divisional GBN</option>
      <option value="98">Legal Adviser</option>
    </SelectMenu>
  </div>
)}

{/* Conciliation cause list: forum */}
{formData.state === "UPRERA" && formData.uprera_search_type === "conciliation-cause-list" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Forum <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="uprera_forum_code"
      value={formData.uprera_forum_code}
      onChange={handleInputChange}
      className={selectStyles}
    >
      <option value="">-- Select Forum --</option>
      <option value="1">Greater Noida</option>
      <option value="2">Lucknow</option>
    </SelectMenu>
  </div>
)}

{/* Cause list hearing date (both cause-list types) */}
{formData.state === "UPRERA" &&
  ["complaint-cause-list", "conciliation-cause-list"].includes(formData.uprera_search_type) && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Hearing Date <span className="text-red-500">*</span>
    </label>
    <input
      type="date"
      name="uprera_hearing_date"
      value={formData.uprera_hearing_date}
      onChange={handleInputChange}
      className={inputStyles}
      style={{ backgroundColor: "white", color: "black" }}
    />
  </div>
)}

{formData.state === "UP" && formData.search_by === "4" && (
  <>
    <div>
      <label className="block mb-1.5 text-slate-600 text-sm font-medium">
        Select Type <span className="text-red-500">*</span>
      </label>

      <SelectMenu
        name="party_type"
        value={formData.party_type}
        onChange={handleInputChange}
        className={selectStyles}
        required
      >
        <option value="1">Main Party</option>
        <option value="2">Additional Party</option>
      </SelectMenu>
    </div>

    <input
  type="text"
  placeholder="Type party name"
  value={partyQuery}
  onChange={(e) => {
    const raw = e.target.value;

    setPartyQuery(raw); // ✅ raw input (spaces allowed)
    setFormData(prev => ({
      ...prev,
      party_name: raw
    }));
  }}
  onBlur={() => {
    const formatted = toTitleCase(partyQuery);

    setPartyQuery(formatted);
    setFormData(prev => ({
      ...prev,
      party_name: formatted
    }));
  }}
  className={inputStyles}
  autoComplete="off"
  required
/>

  </>
)}

{formData.state === "UP" && formData.search_by === "5" && (
  <div className="relative">
   <input
  type="text"
  placeholder="Type advocate name"
  value={advocateQuery}
  onChange={(e) => {
    const raw = e.target.value;

    setAdvocateQuery(raw); // ✅ keep raw input
    setFormData(prev => ({
      ...prev,
      advocate_name: raw
    }));

    fetchAdvocateSuggestions(raw);
  }}
  onBlur={() => {
    // ✅ format ONLY when user leaves input
    const formatted = toTitleCase(advocateQuery);
    setAdvocateQuery(formatted);
    setFormData(prev => ({
      ...prev,
      advocate_name: formatted
    }));
  }}
  className={inputStyles}
  autoComplete="off"
  required
/>


    {advocateLoading && (
      <div className="absolute bg-white text-black text-sm px-3 py-2 w-full">
        Loading…
      </div>
    )}

    {advocateSuggestions.length > 0 && (
      <ul className="absolute z-50 bg-white text-black w-full border border-gray-300 rounded max-h-48 overflow-auto">
        {advocateSuggestions.map((name) => (
          <li
            key={name}
            className="px-3 py-2 hover:bg-slate-100 cursor-pointer"
            onClick={() => {
              setAdvocateQuery(name);
              setFormData(prev => ({
                ...prev,
                advocate_name: name
              }));
              setAdvocateSuggestions([]);
            }}
          >
            {name}
          </li>
        ))}
      </ul>
    )}
  </div>
)}


{formData.state === "UP" && formData.search_by === "6" && (
  <SelectMenu
    name="select_judge"
    value={formData.select_judge || ""}
    onChange={handleInputChange}
    className={selectStyles}
    required
  >
    <option value="">Select Judge</option>
    <option value="1">Tej Bahadur Singh</option>
    <option value="3">Dr. Justice Devendra Kumar Arora</option>
    <option value="4">Rajiv Misra</option>
    <option value="8">Atul Kumar Gupta</option>
    <option value="10">Justice Suneet Kumar</option>
    <option value="7">Sanjai Khare</option>
    <option value="6">Munish Chandra Jauhari</option>
    <option value="9">Rameshwar Singh</option>
    <option value="5">Kamal Kant Jain</option>
    <option value="11">Devindar Singh Chaudhry</option>
  </SelectMenu>

)}

{formData.state === "UP" && formData.search_by === "6" && (
  <>
    <input
      type="date"
      name="from_date"
      value={formData.from_date}
      onChange={handleInputChange}
      className={inputStyles}
    />

    <input
      type="date"
      name="to_date"
      value={formData.to_date}
      onChange={handleInputChange}
      className={inputStyles}
    />
  </>
)}






{formData.state === "UP" &&
  [ "2", "3"].includes(formData.search_by) && (
    <div>
      <label className="block mb-1.5 text-slate-600 text-sm font-medium">
        Case Type <span className="text-red-500">*</span>
      </label>
      <SelectMenu
        name="case_type"
        value={formData.case_type}
        onChange={handleInputChange}
        className={selectStyles}
        required
      >

      <option value="">-- Select Case Type --</option>
          <option value="1">Appeal</option>
          <option value="2">Stay of Order(SO)</option>
          <option value="3">Caveat Petition(CP)</option>
          <option value="4">Interim Relief Application(IRP)</option>
          <option value="5">Condonation of Delay(CD)</option>
          <option value="6">Urgent Hearing(UH)</option>
          <option value="7">Tagging and Clubbing Application(TC)</option>
          <option value="8">Ex-Parte Order(EO)</option>
          <option value="9">Interim Relief(IR)</option>
          <option value="10">Joining as Appellant/ Respondent(JA)</option>
          <option value="11">Providing additional evidence(PA)</option>
          <option value="12">Extension of time to deposit(ET)</option>
          <option value="13">Withdrawa of Appeal(WA)</option>
          <option value="14">Addition of Party(AP)</option>
          <option value="15">Execution of Order(EO)</option>
          <option value="16">Diff. Misc. case(DMC)</option>
          <option value="17">Rectification(RN)</option>
          <option value="18">Review Application(RP)</option>
          <option value="19">Refund of Deposit(RD)</option>
          <option value="20">Waver of Deposit(WD)</option>
          <option value="21">Settlement Application(SA)</option>
          <option value="22">Miscellaneous/Defective Appeal(Misc. Case)</option>
          <option value="23">Execution Applications(EA)</option>
          <option value="24">Recall Application(RA)</option>
          <option value="25">Restoration Application(RA)</option>
    </SelectMenu>
  </div>
)}

      {formData.state === "DELHI" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case Category <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="delhi_case_category"
      value={formData.delhi_case_category}
      onChange={handleInputChange}
      className={selectStyles}
      required
    >
      <option value="">-- Select Category --</option>
      <option value="complaint">Complaint Cases</option>
      <option value="execution">Execution Cases</option>
      <option value="registration">Registration</option>
      <option value="general">General</option>
      <option value="suo-moto">Suo-Moto</option>
    </SelectMenu>
  </div>
)}

{formData.state === "UP" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Zonal Bench <span className="text-red-500">*</span>
    </label>

    <SelectMenu
      name="zonal_bench"
      value={formData.zonal_bench}
      onChange={handleInputChange}
      className={selectStyles}
      required
    >
      <option value="">-- Select Zonal Bench --</option>
      <option value="1">UPREAT LUCKNOW</option>
    </SelectMenu>
  </div>
)}
      
  {formData.state === "DELHI" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case Sub-Category <span className="text-red-500">*</span>
    </label>

    <SelectMenu
      name="delhi_case_subcategory"
      value={formData.delhi_case_subcategory}
      onChange={handleInputChange}
      className={selectStyles}
      required
    >
      <option value="">-- Select Sub-Category --</option>

      {DELHI_SUBCATEGORY_MAP[formData.case_status]?.[
        formData.delhi_case_category
      ]?.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </SelectMenu>
    

  </div>
  


)}

{formData.state === "HARYANA" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case/Appeal Authority <span className="text-red-500">*</span>
    </label>
    <SelectMenu
      name="haryana_authority"
      value={formData.haryana_authority}
      onChange={handleInputChange}
      className={selectStyles}
      required
    >
      <option value="">-- Select --</option>
      <option value="RERA-PKL">RERA-PKL</option>
      <option value="RERA-GRG">RERA-GRG</option>
      <option value="H-REAT">H-REAT</option>
    </SelectMenu>
  </div>
)}

{formData.state === "HARYANA" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case/Appeal No <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="haryana_case_no"
      value={formData.haryana_case_no}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter Case/Appeal No"
      required
    />
  </div>
)}

      {/* Zonal Bench */}


      {/* Case Type */}

    </div>

    {/* RIGHT COLUMN - 3 fields */}
    <div className="space-y-4 px-6 ml-4 md:px-0 md:pl-8">
      {formData.state === "DELHI" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Zonal Bench <span className="text-red-500">*</span>
    </label>

    <SelectMenu
      name="zonal_bench"
      value={formData.zonal_bench}
      onChange={handleInputChange}
      className={selectStyles}
      required
    >
      <option value="">-- Select Zonal Bench --</option>
      <option value="DELHIREAT-Shivaji Stadium Annexe Building">
        DELHIREAT - Shivaji Stadium Annexe Building
      </option>
    </SelectMenu>
  </div>
)}

{formData.state === "HARYANA" && (
  <div className="relative">
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case/Appeal Year <span className="text-red-500">*</span>
    </label>
    <DatePicker
      selected={formData.haryana_case_year ? new Date(formData.haryana_case_year, 0, 1) : null}
      onChange={(date) => {
        if (date) {
          setFormData(prev => ({ ...prev, haryana_case_year: date.getFullYear().toString() }));
        }
      }}
      showYearPicker
      dateFormat="yyyy"
      maxDate={new Date()}
      minDate={new Date(2018, 0, 1)}
      placeholderText="Select Year"
      wrapperClassName="w-full"
      customInput={
        <input
          type="text"
          className={inputStyles}
          style={{ backgroundColor: 'white', color: 'black' }}
        />
      }
      required
    />
    <Calendar className="absolute top-[60%] right-[28%] transform -translate-y-1/2 text-slate-500 pointer-events-none w-4 h-4" />
  </div>
)}

{formData.state === "HARYANA" && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Captcha <span className="text-red-500">*</span>
    </label>

    <div className="flex items-center gap-3 mb-3">
      {captchaLoading ? (
        <div className="flex items-center gap-2 h-12 px-3 rounded-md border border-slate-300 bg-slate-50">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-yellow-500/30 border-t-yellow-500"></span>
          <span className="text-slate-600 text-sm">Loading captcha…</span>
        </div>
      ) : captchaUrl ? (
        <img
          src={captchaUrl}
          alt="CAPTCHA"
          className="h-12 object-contain rounded-md border border-slate-300 bg-slate-50"
        />
      ) : (
        <p className="text-red-400 text-sm">{captchaError || "Captcha unavailable"}</p>
      )}

      <button
        type="button"
        onClick={loadCaptcha}
        className="bg-blue-500 text-white p-2.5 rounded hover:bg-blue-600"
      >
        <RefreshCw size={18} />
      </button>
    </div>

    <input
      type="text"
      name="haryana_captcha"
      value={formData.haryana_captcha}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter captcha"
      required
    />
  </div>
)}

      {/* Case Year */}
      <div>
        {/* Case Year (ONLY for Case Type / Year) */}
{formData.state === "UP" && ["1", "3", "4", "5", "2"].includes(formData.search_by) && (

  <div className="relative">
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case Year <span className="text-red-500">*</span>
    </label>

    <DatePicker
      selected={formData.case_year ? new Date(formData.case_year, 0, 1) : null}
      onChange={(date) => {
        if (date) {
          setFormData(prev => ({ ...prev, case_year: date.getFullYear().toString() }));
        }
      }}
      showYearPicker
      dateFormat="yyyy"
      maxDate={new Date()}
      minDate={new Date(1970, 0, 1)}
      placeholderText="Select Year"
      wrapperClassName="w-full"
      customInput={
        <input
          type="text"
          className={inputStyles}
          style={{ backgroundColor: 'white', color: 'black' }}
        />
      }
      required
    />
    <Calendar className="absolute top-[60%] right-[28%] transform -translate-y-1/2 text-slate-500 pointer-events-none w-4 h-4" />
  </div>
)}


      </div>

      {/* Case Number */}
      <div>
        {/* Case Number (ONLY for Case No / Filing No) */}
{formData.state === "UP" && ["1", "3"].includes(formData.search_by) && (
  <div>
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Case Number <span className="text-red-500">*</span>
    </label>

    <input
      type="text"
      name="case_number"
      value={formData.case_number}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter case number"
      required
    />
  </div>
)}



      </div>

      {/* CAPTCHA */}
      <div className="flex-grow">
        {formData.state === "UP" && (
  <div className="flex-grow">
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Captcha <span className="text-red-500">*</span>
    </label>

    <div className="flex items-center gap-3 mb-5">
      {captchaLoading ? (
        <div className="flex items-center gap-2 h-12 px-3 rounded-md border border-slate-300 bg-slate-50">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-yellow-500/30 border-t-yellow-500"></span>
          <span className="text-slate-600 text-sm">Loading captcha…</span>
        </div>
      ) : captchaUrl ? (
        <img
          src={captchaUrl}
          alt="CAPTCHA"
          className="h-12 object-contain rounded-md border border-slate-300 bg-slate-50"
        />
      ) : (
        <p className="text-red-400 text-sm">{captchaError || "Captcha unavailable"}</p>
      )}

      <button
        type="button"
        onClick={loadCaptcha}
        className="bg-blue-500 text-white p-2.5 rounded hover:bg-blue-600"
      >
        <RefreshCw size={18} />
      </button>
    </div>

    <input
      type="text"
      name="answer"
      value={formData.answer}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter captcha"
      required
    />
  </div>
)}

{/* UP RERA captcha (the four captcha-based search types) */}
{formData.state === "UPRERA" && UPRERA_CAPTCHA_TYPES.includes(formData.uprera_search_type) && (
  <div className="flex-grow">
    <label className="block mb-1.5 text-slate-600 text-sm font-medium">
      Captcha <span className="text-red-500">*</span>
    </label>

    <div className="flex items-center gap-3 mb-3">
      {captchaLoading ? (
        <div className="flex items-center gap-2 h-12 px-3 rounded-md border border-slate-300 bg-slate-50">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-yellow-500/30 border-t-yellow-500"></span>
          <span className="text-slate-600 text-sm">Loading captcha…</span>
        </div>
      ) : upReraCaptcha1 ? (
        <img
          src={upReraCaptcha1}
          alt="CAPTCHA"
          className="h-12 object-contain rounded-md border border-slate-300 bg-slate-50"
        />
      ) : (
        <p className="text-red-400 text-sm">{captchaError || "Captcha unavailable"}</p>
      )}

      <button
        type="button"
        onClick={loadUpReraCaptcha}
        className="bg-blue-500 text-white p-2.5 rounded hover:bg-blue-600"
      >
        <RefreshCw size={18} />
      </button>
    </div>

    <input
      type="text"
      name="uprera_captcha"
      value={formData.uprera_captcha}
      onChange={handleInputChange}
      className={inputStyles}
      placeholder="Enter captcha"
    />

    {/* Second captcha — only Get Complaint Number issues two */}
    {upReraCaptcha2 && (
      <>
        <div className="flex items-center gap-3 mb-3 mt-4">
          <img
            src={upReraCaptcha2}
            alt="CAPTCHA 2"
            className="h-12 object-contain rounded-md border border-slate-300 bg-slate-50"
          />
        </div>
        <input
          type="text"
          name="uprera_captcha2"
          value={formData.uprera_captcha2}
          onChange={handleInputChange}
          className={inputStyles}
          placeholder="Enter second captcha"
        />
      </>
    )}
  </div>
)}
      </div>
    </div>
  </div>
  </div>

  {/* Footer — tips + action */}
  <div className="flex flex-col gap-4 border-t border-slate-100 bg-slate-50/60 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
    <ul className="flex flex-wrap items-center gap-x-5 gap-y-1">
      {["Select a State to begin", "Solve the captcha exactly as shown", "Fields marked * are required"].map((tip) => (
        <li key={tip} className="flex items-center gap-1.5 text-xs text-slate-500">
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-yellow-400" />
          {renderTip(tip)}
        </li>
      ))}
    </ul>
    <button
      type="submit"
      className="h-10 shrink-0 rounded-lg bg-yellow-500 px-8 text-sm font-semibold text-slate-900 transition-colors hover:bg-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
      disabled={
  loading ||
  ((formData.state === "UP" || formData.state === "HARYANA") && (!sessionId || !captchaUrl)) ||
  (formData.state === "UPRERA" &&
    UPRERA_CAPTCHA_TYPES.includes(formData.uprera_search_type) &&
    (!upReraCaptcha1 || !upReraViewState || !upReraJar))
}

    >
      {loading ? "Searching..." : "Search Cases"}
    </button>
  </div>
</form>
            </div>
          </div>

          {showDebug && (
            <div className="relative z-10 mx-auto md:w-3/4 w-11/12 mb-8">
              <div className="rounded-lg border border-slate-200 bg-white p-6">
                <h3 className="text-slate-800 text-lg font-bold mb-4">Debug Information:</h3>
                <pre className="bg-slate-50 border border-slate-200 p-4 rounded text-sm text-slate-700 overflow-auto max-h-96">
                  {debugInfo}
                </pre>
              </div>
            </div>
          )}
        </main>
    </div>
  );
}

export default ReraCaseSearch;